import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M807.18584,686.592055 L1080.05012,959.456333 L0,959.456333 L0,1072.39684 L1080.05012,1072.39684 L807.18584,1345.37406 L886.921842,1425.223 L1296.21826,1016.03953 L886.921842,606.856054 L807.18584,686.592055 Z M1870.41912,434.689537 L1541.19752,105.580885 C1509.68712,74.0704819 1465.97914,56 1421.48058,56 L451.773343,56 L451.773343,786.612173 L564.713855,786.612173 L564.713855,168.940512 L1355.29744,168.940512 L1355.29744,620.702561 L1807.05949,620.702561 L1807.05949,1750.10768 L564.713855,1750.10768 L564.713855,1241.87538 L451.773343,1241.87538 L451.773343,1863.04819 L1920,1863.04819 L1920,554.51942 C1920,509.343216 1902.38128,466.764643 1870.41912,434.689537 L1870.41912,434.689537 Z M1468.23795,192.319198 L1783.6808,507.762048 L1468.23795,507.762048 L1468.23795,192.319198 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSisImportedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSisImportedLine, _Component);

  var _super = _createSuper(IconSisImportedLine);

  function IconSisImportedLine() {
    _classCallCheck(this, IconSisImportedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSisImportedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSisImported",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconSisImportedLine.displayName = "IconSisImportedLine";
  return IconSisImportedLine;
}(Component);

IconSisImportedLine.glyphName = 'sis-imported';
IconSisImportedLine.variant = 'Line';
IconSisImportedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSisImportedLine;
export { IconSisImportedLine };